import { render, staticRenderFns } from "./NewsAdd.vue?vue&type=template&id=57cc8d1e&scoped=true&"
import script from "./NewsAdd.vue?vue&type=script&lang=js&"
export * from "./NewsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cc8d1e",
  null
  
)

export default component.exports